import downloadFile from "utils/downloadFile";
import { useState } from "react";

export default function useCreateDownload(
  url: string | undefined | null,
  filename: string,
) {
  const [isDownloading, setIsDownloading] = useState(false);
  const [error, setError] = useState<Error | undefined>();
  const [downloadProgress, setDownloadProgress] = useState<number>(0);

  async function onDownload() {
    if (!url) return;

    setIsDownloading(true);
    setError(undefined);
    setDownloadProgress(0);

    try {
      await downloadFile({
        url,
        filename,
        onProgress: setDownloadProgress,
      });
    } catch (downloadError) {
      const normalizedError =
        downloadError instanceof Error
          ? downloadError
          : new Error(String(downloadError));
      setError(normalizedError);
      console.error("Error downloading file:", normalizedError);
    } finally {
      setIsDownloading(false);
    }
  }

  return { error, onDownload, isDownloading, downloadProgress };
}
